import { Component, ViewEncapsulation, Input, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridEditLineComponent } from '@app/cp/shared/base-components/base-grid-editline.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { InventoryReference } from '../../../shared/models/InventoryReference';
import { SaveMode } from '../../../shared/enums/SaveMode';
import { InventoryPartNbrsBus } from '../../../shared/models/InventoryPartNbrsBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'cp-part-nbrs',
    templateUrl: './part-nbrs.component.html',
    styleUrls: ['./part-nbrs.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PartNbrsComponent extends BaseGridEditLineComponent<InventoryPartNbrsBus, null, InventoryService> {

    @Input() inventoryReferenceData: InventoryReference

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);
        this.className = "InventoryPartNbrsBus";
        this.appCode = "InventoryPartNbrs";
        this.saveMode = SaveMode.all;
        this.disableCpSearchDialog();
    }

    override createForm() {
        this.editForm = new UntypedFormGroup({
            'partNbr': new UntypedFormControl(null, Validators.required),
            'barCode': new UntypedFormControl(),
            'manufacturerId': new UntypedFormControl(null, Validators.required),

        });

    }

    override setForm() {
        this.editForm.patchValue({
            partNbr: this.selectedData.partNbr,
            barCode: this.selectedData.barCode,
            manufacturerId: this.selectedData.manufacturerId,
        });

    }

    override processGridData() {
        if (!this.grid || this.editedRowIndex < 0) {
            return
        }
        this.grid.closeRow(this.editedRowIndex);
    }
}
